'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('feedback', {
    url: '/feedback',
    template: '<feedback></feedback>'
  });
}



// WEBPACK FOOTER //
// ./client/app/feedback/feedback.routes.js